import React, { useMemo, useState } from 'react';
import { BellRing, X } from 'lucide-react';

export default function BedAvailabilityAlert({ reservations, beds }) {
    const [visible, setVisible] = useState(true);

    // Lógica para encontrar "Oportunidades de Internação"
    const opportunities = useMemo(() => {
        if (!visible) return [];

        // 1. Pegar reservas confirmadas
        const confirmed = reservations.filter(r => r.status === 'confirmed');
        if (confirmed.length === 0) return [];

        const matches = [];

        // 2. Para cada reserva confirmada, ver se tem vaga no setor
        confirmed.forEach(res => {
            const hasBed = beds.some(b =>
                b.sector_id == res.sector_id &&
                (b.statusId === 1 || b.statusId === 9) // Livre ou Higienizado
            );

            if (hasBed) {
                matches.push(res);
            }
        });

        return matches;
    }, [reservations, beds, visible]);

    if (opportunities.length === 0) return null;

    return (
        <div className="fixed bottom-20 right-4 z-50 max-w-sm w-full animate-in slide-in-from-bottom-5 fade-in duration-300">
            <div className="bg-white dark:bg-gray-800 border-l-4 border-green-500 rounded-lg shadow-xl p-4 relative">
                <button
                    onClick={() => setVisible(false)}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                    <X size={16} />
                </button>

                <div className="flex items-start gap-3">
                    <div className="p-2 bg-green-100 text-green-600 rounded-full shrink-0">
                        <BellRing size={20} />
                    </div>
                    <div>
                        <h4 className="font-bold text-gray-900 dark:text-white text-sm">
                            Vagas Disponíveis Encontradas!
                        </h4>
                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                            Existem {opportunities.length} reservas que já podem ser internadas agora. Há leitos vagos nos setores de destino.
                        </p>

                        <div className="mt-3 flex gap-2">
                            <button
                                onClick={() => {
                                    document.getElementById('root').scrollIntoView({ behavior: 'smooth' }); // Scroll to top (dashboard)
                                }}
                                className="text-xs font-bold text-green-700 hover:text-green-800 underline"
                            >
                                Ver Painel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
